<template>
    <svg width="96" height="92" viewBox="0 0 96 92" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="mask0_6469_1467" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="96" height="92">
            <path d="M96 0.170898H0V91.6176H96V0.170898Z" fill="white" />
        </mask>
        <g mask="url(#mask0_6469_1467)">
            <path
                d="M95.9999 82.9775L73.3999 62.7709C82.7133 48.8575 83.9133 30.2775 73.0399 16.7442C57.6399 -2.42912 31.7666 -4.97578 14.4533 9.15755C-1.82674 
                    22.4375 -4.0934 46.4775 6.33993 62.3375C17.8933 79.8909 47.9999 85.2975 63.6133 73.2642C64.6066 72.4975 65.5599 71.6842 66.4799 70.8442L88.3133 
                    91.6175L95.9999 82.9842V82.9775ZM15.7733 56.2109C8.23993 44.7642 9.97993 27.5375 21.6266 17.8242C32.9533 8.38421 52.8933 9.38422 63.9133 23.3042C74.4399 
                    36.6042 68.7799 54.7642 56.3666 64.7042C44.5333 74.1909 24.1066 68.8775 15.7666 56.2109H15.7733Z"
                fill="#D3D3CB"
            />
            <path
                d="M63.9131 23.3041C52.8931 9.38414 32.9531 8.38413 21.6265 17.8241C9.9798 27.5375 8.23981 44.7641 15.7731 56.2108C24.1131 68.8775 44.7998 74.5108 
                    56.3731 64.7041C69.4331 53.6441 74.4465 36.6041 63.9198 23.3041H63.9131Z"
                fill="#00D672"
                />
            <path
                d="M30.5 26.1376C32.5533 25.0909 35.32 24.3242 38.66 24.3242C47.9133 24.3242 52.4467 29.1909 52.4467 35.9642C52.4467 41.7842 46.82 46.2709 39.6133 
                    46.2709C37.8933 46.2709 36.4667 46.0776 35.2733 45.7976V39.8842C36.32 40.1242 37.5133 40.2176 38.8067 40.2176C42.72 40.2176 44.82 38.4042 44.82 
                    36.2109C44.82 33.7776 42.72 32.0109 38 32.0109C34.7067 32.0109 32.2267 32.8242 30.5067 33.8709V26.1442L30.5 26.1376ZM39.3267 49.0842C42.14 49.0842 
                    44.1 50.7509 44.1 53.5709C44.1 56.3909 42 58.1976 39.3267 58.1976C36.6533 58.1976 34.5533 56.4309 34.5533 53.5709C34.5533 50.7109 36.5067 49.0842 
                    39.3267 49.0842Z"
                fill="white"
            />
        </g>
    </svg>
</template>
